//CONNEXION AU BACK OFFICE : jeton + informations de l'utilisateur connecté (null si déconnecté)
//Cet état est conservé par redux-persist : on reste connecté après un rechargement de la page.

export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

const initialState = null; // { token, user: { firstName, lastName, role } }

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_LOGIN:
      return action.payload;
    case AUTH_LOGOUT:
      return null;
    default:
      return state;
  }
};
